export default object => ({
  id: object.id,
  year: object.year,
  number: object.number,
  typeName: object.typeName,

  fileStream: null,

  files: object.archives.map(({ id, name, key, url }) => ({
    id,
    name,
    key,
    url,
  })) || [],
});
